module.exports = __webpack_public_path__ + "static/media/footerLogo.2d786c6c.svg";